export function timeUtilization(allocated, actual) {
  if (allocated == null || actual == null || !Number.isFinite(allocated) || !Number.isFinite(actual) || allocated < 0) {
    return { label: '—', level: 'unknown' };
  }
  if (allocated === 0) return actual > 0
    ? { label: 'No allocation', level: 'over' }
    : { label: '—', level: 'unknown' };
  const percent = actual / allocated * 100;
  const level = percent > 100 ? 'over' : percent >= 90 ? 'near' : 'normal';
  // Keep displayed rounding from crossing the warning thresholds.
  const displayed = level === 'over' ? Math.ceil(percent * 100) / 100 : Math.floor(percent * 100) / 100;
  return { label: `${displayed.toLocaleString(undefined, { maximumFractionDigits: 2 })}%`, level };
}
